<form class="vl-form" id="edit-invoice-settings-form">
    <vl-modal :id="modalId" :closable="true" mod-medium>
        <vl-title tag-name="h3">{{ title }}</vl-title>
        <vl-u-spacer mod-small/>
        
        <p>InvoiceSettingId: <strong>{{ settings.invoiceSettingsId }}</strong></p>
        <vl-u-spacer mod-small/>
        
        <vl-form-grid mod-stacked>
            <vl-column width="12">
                <vl-form-message-label for="invoiceReference">Eigen referentie</vl-form-message-label>
                <vl-input-field
                    id="invoiceReference"
                    v-model="invoiceReference"
                    mod-block
                    name="invoiceReference"
                    placeholder="Eigen referentie (optioneel)"
                    :mod-error="!!errors.invoiceReference"
                />
                <vl-form-validation-message v-if="errors.invoiceReference">
                    {{ errors.invoiceReference }}
                </vl-form-validation-message>
                <vl-form-annotation>
                    Eventueel bestelbonnummer / PO-nummer dat op toekomstige PostPaid facturen geplaatst zal worden (max. 35 karakters)
                </vl-form-annotation>
            </vl-column>
            
            <vl-column width="12">
                <vl-form-message-label for="forTheAttentionOf">T.a.v.</vl-form-message-label>
                <vl-input-field
                    id="forTheAttentionOf"
                    v-model="forTheAttentionOf"
                    mod-block
                    name="forTheAttentionOf"
                    placeholder="Ter attentie van (optioneel)"
                    :mod-error="!!errors.forTheAttentionOf"
                />
                <vl-form-validation-message v-if="errors.forTheAttentionOf">
                    {{ errors.forTheAttentionOf }}
                </vl-form-validation-message>
                <vl-form-annotation>
                    Eventuele 'Ter attentie van'-waarde die op toekomstige PostPaid facturen geplaatst zal worden
                </vl-form-annotation>
            </vl-column>
        </vl-form-grid>
        
        <template v-slot:modal-footer>
            <vl-action-group>
                <vl-button 
                    mod-large 
                    :mod-disabled="invalidForm || isSaving"
                    @click.prevent="handleFormSubmit">
                    {{ isSaving ? 'Bezig met opslaan...' : 'Wijzigingen opslaan' }}
                </vl-button>&nbsp;
                <vl-link @click.prevent="onCloseModal" icon="cross" mod-icon-before>
                    Annuleer
                </vl-link>
            </vl-action-group>
        </template>
    </vl-modal>
</form>

